import React from "react";
import { connect } from "react-redux";
import { Action } from "redux";
import { ThunkDispatch } from "redux-thunk";
import { storagePoolActions } from "../../../../redux/actions/shard-cluster";
import { IAppState } from "../../../../redux/reducers";
import { InfoDialog } from "../../../shared-ui/dialogs/common/info-dialog/info-dialog";
import styles from "./credentials-info.module.scss";


const mapDispatchToProps = (
  dispatch: ThunkDispatch<IAppState, void, Action>
) => {
  return {
    closeExcessiveCredentialsConfirmation: () => {
      dispatch(storagePoolActions.credentialsInfo.close());
    }
  };
};

const mapStateToProps = (state: IAppState) => ({
  isOpen: state.shardCluster.credentialsConfirmation.isOpen,
  data: state.shardCluster.credentialsConfirmation.data,
});

export interface IDeleteConfirmationProps extends 
    ReturnType<typeof mapDispatchToProps>,
    ReturnType<typeof mapStateToProps> {
}

export const CredentialsInfo = connect(mapStateToProps, mapDispatchToProps)((props: IDeleteConfirmationProps) => {
  const credentialType = props.data?.isConnectionSuccessful ? 'excessive': 'insufficient';
  const message = props.data?.isConnectionSuccessful ?
      'Are you sure you want to use the provided credentials?':
      'Provided credentials cannot be used further.';

  return (
    <InfoDialog
      testId="credentials-confirmation"
      title={`Storage Node Credentials provide ${credentialType} permissions`}
      open={props.isOpen}
      showOkButton={true}
      onClose={props.closeExcessiveCredentialsConfirmation}
    >
      <div className={styles.content}>
        <div className={styles.message}>{message}</div>

        {props.data &&
          <>
            {/* TODO MP-3916, Access Credentials, scope */}
            <div className={styles.hidden}>Required scope: <span className={styles.scope}>{props.data?.scope}</span></div>

            <section>
              {props.data?.operationStatus &&
                  <>
                    <div>Operation</div>
                    <div>Result</div>
                    {
                      Object.keys(props.data.operationStatus).map(x => <>
                        <div>{x}</div>
                        <div>{props.data.operationStatus[x] ? '+' : '-'}</div>
                      </>)
                    }
                  </>
              }
            </section>
          </>
        }
      </div>
    </InfoDialog>
  );
});
